import { render, staticRenderFns } from "./InvitacionesPasoPago.vue?vue&type=template&id=6b72e063"
import script from "./InvitacionesPasoPago.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesPasoPago.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports